<template>
  <b-card
    v-if="enabled"
    header="Debug Console"
    header-bg-variant="dark"
    header-class="header"
    body-text-variant="dark"
    body-class="body"
  >
    <textarea readonly class="debug-messages" :value="messages"></textarea>
  </b-card>
</template>

<script lang="ts">
import Vue from 'vue'
import Component from 'vue-class-component'
import { useLoggingStore } from '@/store/common/logging'
import { settingsService } from '@/services'

@Component
export default class DebugConsole extends Vue {
  loggingStore = useLoggingStore()

  get enabled() {
    return settingsService.debugConsoleEnabled
  }

  get messages() {
    return this.loggingStore.allMessages.join('\n')
  }
}
</script>

<style scoped>
.header {
  padding: 0.1rem 0.5em;
}

.body {
  padding: 0.2rem 0.5rem;
}

.debug-messages {
  width: 100%;
  height: 100%;
  border: none;
  background: none;
  text-wrap: nowrap;
}
</style>
